import React from 'react';
import guide from './guide-how-website-visitor-works.png';
import styles from './HowXRayWorksVersionA.module.css';

export const HowXRayWorksVersionA = ({
  websiteURL,
  isWhiteLabel,
}: {
  websiteURL: string;
  isWhiteLabel?: boolean;
}) => (
  <div className={styles.container}>
    <div className={styles.title}>
      <div className={styles.titleBold}>
        How does {isWhiteLabel ? '' : 'Customers.ai X-Ray pixel'} website
        visitor identification work?
      </div>
      <div>
        {isWhiteLabel ? 'Our tool' : 'Customers.ai X-Ray Pixel'} automatically
        captures emails from{' '}
        <span className={styles.website}>{websiteURL}</span> website traffic.
      </div>
    </div>
    <div className={styles.imageContainer}>
      <img src={guide} className={styles.image} />
    </div>
  </div>
);
